import { FORMULA_PATH } from '@/constants/paths';
import type { MyIngredientsPageQueryParams } from '@/components/screens/MyIngredientsPage/MyIngredientsPage.model';

export const getMyIngredientsPageUrl = (
  filters?: Partial<MyIngredientsPageQueryParams>,
) => {
  if (!filters) return FORMULA_PATH;

  const filterSearchParams = new URLSearchParams(
    filters as Record<string, string>,
  );

  return `${FORMULA_PATH}?${filterSearchParams}`;
};
